export default "__VITE_ASSET__CHBLveyN__";